var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#FFE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C34.2091 20 36 21.7909 36 24C36 26.2091 34.2091 28 32 28C29.7909 28 28 26.2091 28 24C28 21.7909 29.7909 20 32 20Z",
    fill: "#FF4DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 36C42.2091 36 44 37.7909 44 40C44 42.2091 42.2091 44 40 44C37.7909 44 36 42.2091 36 40C36 37.7909 37.7909 36 40 36Z",
    fill: "#FF4DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C26.2091 36 28 37.7909 28 40C28 42.2091 26.2091 44 24 44C21.7909 44 20 42.2091 20 40C20 37.7909 21.7909 36 24 36Z",
    fill: "#FF4DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28V36M24 40H40",
    stroke: "#FF4DFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildCare);
export default __webpack_public_path__ + "static/media/child-care.3ac9e6326d13d7ed9266a7fc7f27d13c.svg";
export { ForwardRef as ReactComponent };